import Modal from "components/layout/modal";
import { FunctionComponent, useEffect, useState } from "react";
import { cast, FormValues } from "lib/form";
import { adminDoGetListEmailTemplates } from "services/admin/list-email-template";
import { ListEmailTemplate } from "models/list-email-template";
import { LocaleString } from "models/locale";
import { ListSchedule, RecipientType } from "models/list-schedule";
import { adminDoPostListInvitationEmail } from "services/admin/list-invitation-email";
import { adminDoPostListUserInvitation } from "services/admin/list-invitation";
import { adminDoGetListUsers } from "services/admin/list-user";
import { filterUsers } from "lib/user";
import { adminDoPatchListSchedule } from "services/admin/list-schedule";
import EditScheduleModalForm from "./edit-schedule-modal-form";
import { List } from "models/list";
import { parse } from "lib/locale";

interface EditScheduleModalProps {
  list: List;
  listSchedule: ListSchedule;
  onUpdate: () => Promise<void>;
  onClose: () => Promise<void>;
}

interface FormModel {
  recipients: RecipientType;
  send_at: Date | undefined;
  subject: LocaleString;
  message: LocaleString;
}

const EditScheduleModal: FunctionComponent<EditScheduleModalProps> = ({
  list,
  listSchedule,
  onUpdate,
  onClose,
}) => {
  const [emailTemplates, toggleTemplates] = useState<
    ListEmailTemplate[] | undefined
  >(undefined);

  const update = async () => {
    const emailTemplates = await adminDoGetListEmailTemplates(list);
    toggleTemplates(emailTemplates);
  };

  useEffect(() => {
    update();
  }, []);

  if (!emailTemplates) {
    return null;
  }

  const onSubmit = async (values: FormValues) => {
    const vals = cast<FormModel>(values);
    const { subject, message, send_at, recipients } = vals;

    // save to server
    if (send_at) {
      // create a schedule and send later
      await adminDoPatchListSchedule(list, listSchedule.uuid, {
        send_at: send_at.toISOString(),
        subject,
        message,
        recipients,
      });
    } else {
      try {
        // send immediately
        const users = await adminDoGetListUsers(list);

        const filteredUsers = filterUsers(users, recipients);

        for (let i = 0; i < filteredUsers.length; i += 1) {
          const user = filteredUsers[i];

          // create invitation
          const invitation = await adminDoPostListUserInvitation(
            list,
            user.uuid,
          );

          // create actual email
          await adminDoPostListInvitationEmail(
            list,
            invitation.uuid,
            parse(subject, user.locale),
            parse(message, user.locale),
          );
        }
      } catch (err) {
        // nada
      }
    }

    // signal changes to parent
    await onUpdate();

    // finally, close the modal
    onClose();
  };

  return (
    <Modal title="Muokkaa kutsua" wide>
      <EditScheduleModalForm
        listSchedule={listSchedule}
        emailTemplates={emailTemplates}
        onSubmit={onSubmit}
        onClose={onClose}
      />
    </Modal>
  );
};

export default EditScheduleModal;
